import styles from "./index.module.scss";
import TitleWhithLine from "@/components/TitleWhithLine";
import { memberList } from "@/apis/about";
import Slider from "react-slick";
import {  useEffect, useState } from "react";
import intl from "react-intl-universal";
const WhoUse = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4500,
    autoplaySpeed: 2000,
    cssEase: "linear",
    className: "partnerBox",
  };
  const [list, setList] = useState([]);
  const getList = () => {
    memberList()
      .then((res) => {
        setList(res.data || []);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getList();
  }, []);
  return (
    <div className="container">
      {/* <TitleWhithLine
        title="Who Uses OGE Alliance"
        link="/about/member-listing"
      /> */}
      <h1 className={styles.h1Box}>{intl.get("Who Uses OGE Alliance")}</h1>
      <div className={styles.scroolBox}>
        <Slider {...settings}>
          {list.map((item, index) => {
            return (
              <div
                key={index + "_use"}
                className={styles.singelBox}
                onClick={() => {
                  window.open(item.url, "_blank");
                }}
              >
                <img
                  src={process.env.REACT_APP_API_AFFIX + item.imgPath}
                  alt=""
                />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
export default WhoUse;
